export interface GrowthDropdownOption {
  label?: string;
  value: GrowthTypes;
}

export enum GrowthTypes {
  actual = 'actual',
  percentage = 'percentage',
}

export const isActualGrowthType = (selectedGrowthType: GrowthTypes) => {
  return selectedGrowthType === GrowthTypes.actual;
};
